document.addEventListener('DOMContentLoaded', () => {
    document
        .querySelectorAll('[data-hidden-parent]')
        .forEach(element => {
            initFormToggleableInput(element);
        });
});

function initFormToggleableInput(element) {
    const parentName = element.getAttribute('data-hidden-parent');

    if (!parentName)
        return;

    const parent = document.querySelector(
        `[name="${CSS.escape(parentName)}"]`
    );


    if (!parent)
        return;

    const updateVisibility = () => {
        const value = getElementValue(parent);
        let input = element.querySelector("input, select, textarea");

        if (value) {
            element.classList.remove('hidden');
            element.style.display = "block";
            if (input)
                input.hidden = false;
        } else {
            element.classList.add('hidden');
            element.style.display = "none";
            if (input)
                input.hidden = true;
        }
    };

    parent.addEventListener('input', updateVisibility);
    parent.addEventListener('change', updateVisibility);

    // Set initial state
    updateVisibility();
}

function getElementValue(element) {
    if (element instanceof HTMLSelectElement) {
        return element.value;
    }

    if (element instanceof HTMLInputElement) {
        switch (element.type) {
            case 'checkbox':
            case 'radio':
                return element.checked ? element.value : '';
            default:
                return element.value;
        }
    }

    return element.value ?? '';
}